export default __webpack_public_path__ + "static/media/image 209.ae5c1d9f1bb4df71caf62fe6d1e19f18.svg";